import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import BusinessRuleForm from "./BusinessRuleForm";

export interface State {}

export interface CreateBusinessRuleFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreateBusinessRuleForm extends React.Component<
  CreateBusinessRuleFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = values;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <BusinessRuleForm
        translate={translate}
        getFieldDecorator={getFieldDecorator}
      />
    );
  }
}

export default CreateBusinessRuleForm;
